var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 108,
    x2: 409.027,
    y1: 255,
    y2: 255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff9df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb137"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 104,
    x2: 476.048,
    y1: 255,
    y2: 255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb137"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e41f2d"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.099,
    x2: 429.085,
    xlinkHref: "#lg1",
    y1: 31.291,
    y2: 31.291
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 192,
    x2: 314.102,
    y1: 301.992,
    y2: 301.992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2fbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#faf7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3eae6"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.099,
    x2: 430.595,
    xlinkHref: "#lg1",
    y1: 478.709,
    y2: 478.709
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m435.328 67.189v-51.493h-360.656v51.493c0 43.981 17.471 86.161 48.571 117.26l58.154 58.154c6.847 6.847 6.847 17.948 0 24.794l-58.154 58.154c-31.099 31.099-48.571 73.279-48.571 117.26v51.493h360.655v-51.493c0-43.981-17.471-86.161-48.571-117.26l-58.154-58.154c-6.847-6.847-6.847-17.948 0-24.794l58.154-58.154c31.1-31.099 48.572-73.279 48.572-117.26z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.757 184.449c31.099-31.099 48.571-73.279 48.571-117.26v-51.493h-43.026-317.63v51.493c0 6.625.404 13.207 1.183 19.718h315.263c-4.396 36.717-20.972 71.127-47.387 97.542l-58.154 58.154c-6.847 6.847-6.847 17.948 0 24.794l58.154 58.154c31.099 31.099 48.571 73.279 48.571 117.26v51.493h43.026v-51.493c0-43.981-17.471-86.161-48.571-117.26l-58.154-58.154c-6.847-6.847-6.847-17.948 0-24.794z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.318 0h-354.636c-17.281 0-31.291 14.01-31.291 31.291 0 17.282 14.01 31.291 31.291 31.291h354.636c17.282 0 31.291-14.01 31.291-31.291 0-17.281-14.01-31.291-31.291-31.291z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.275 394.292c-6.66-4.94-13.794-9.313-21.293-13.121-37.418-18.997-61.398-56.961-61.398-98.925v-1.732c0-17.345 6.89-33.98 19.155-46.245l54.768-54.768c9.254-9.254-4.938-18.467-25.054-26.145-45.965-17.545-96.942-17.545-142.906 0-20.116 7.678-34.308 16.891-25.054 26.145l54.768 54.768c12.265 12.265 19.155 28.9 19.155 46.245v1.732c0 41.965-23.98 79.928-61.398 98.925-7.499 3.807-14.633 8.181-21.293 13.12-24.849 18.431-38.808 43.429-38.808 69.495h288.166c0-26.065-13.959-51.063-38.808-69.494z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.318 447.417h-354.636c-17.282 0-31.291 14.01-31.291 31.291 0 17.282 14.01 31.291 31.291 31.291h354.636c17.282 0 31.291-14.01 31.291-31.291 0-17.281-14.01-31.291-31.291-31.291z",
    fill: "url(#SVGID_5_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.d27edac8.svg";
export { ForwardRef as ReactComponent };